<template>
  <header class="nav-wrap">
    <div class="nav-inner">
      <div class="brand" @click="scrollTo('hero')">
        <img class="brand-logo" src="../../../assets/img/logo.png" alt="COG" />
      </div>

      <nav class="nav-list">
        <button v-for="item in navList" :key="item.path" type="button" class="nav-item" @click="scrollTo(item.path)">
          {{ item.name }}
        </button>
      </nav>

      <div class="nav-actions">
        <div
          v-if="isLoggedIn"
          class="profile-entry"
          @mouseenter="profileMenuVisible = true"
          @mouseleave="profileMenuVisible = false"
        >
          <button type="button" class="profile-link" @click="goCenter">
            <img class="profile-avatar" :src="avatarUrl" alt="头像" referrerpolicy="no-referrer" />
            <span>个人中心</span>
          </button>
          <div v-show="profileMenuVisible" class="profile-menu">
            <button type="button" class="profile-menu-item" :disabled="loggingOut" @click="handleLogout">
              {{ loggingOut ? '退出中...' : '退出登录' }}
            </button>
          </div>
        </div>
        <button v-else type="button" class="btn login" @click="goLogin()">登录</button>
        <button type="button" class="btn apply" @click="openApplyDialog">立即申请</button>
      </div>
    </div>
  </header>
</template>

<script>
import { logoutMemberSession } from '@/api/user';
import { clearUserSession, getToken } from '@/utils/auth';
import defaultAvatar from '@/assets/img/user/avatar.png';
import { USER_INFO_UPDATED_EVENT } from '@/utils/userInfo';

export default {
  name: 'Nav',
  data() {
    return {
      defaultAvatar,
      profileMenuVisible: false,
      loggingOut: false,
      token: getToken(),
      userInfo: {},
      navList: [
        { name: '首页', path: 'hero' },
        { name: '重点推荐', path: 'recommend' },
        { name: '扶持政策', path: 'support' },
        { name: '金融服务', path: 'finance' },
		 { name: '数字资产', path: 'assets' }
      ]
    };
  },
  computed: {
    isLoggedIn() {
      return !!this.token;
    },
    avatarUrl() {
      return this.userInfo.avatar || this.defaultAvatar;
    },
    centerPath() {
      return this.userInfo.type === 'mcn' || this.userInfo.type === 'org' ? '/user/org' : '/user/personal';
    }
  },
  created() {
    this.syncUserState();
    window.addEventListener(USER_INFO_UPDATED_EVENT, this.handleUserInfoUpdated);
  },
  beforeDestroy() {
    window.removeEventListener(USER_INFO_UPDATED_EVENT, this.handleUserInfoUpdated);
  },
  methods: {
    handleUserInfoUpdated(event) {
      const userInfo = event && event.detail;
      if (userInfo && typeof userInfo === 'object') {
        this.userInfo = { ...this.userInfo, ...userInfo };
      }
    },
    syncUserState() {
      this.token = getToken();
      try {
        const raw = window.localStorage.getItem('userInfo');
        this.userInfo = raw ? JSON.parse(raw) : {};
      } catch (error) {
        this.userInfo = {};
      }
    },
    openApplyDialog() {
      this.$openApplyDialog({ source: 'front-nav-apply' });
    },
    goLogin() {
      this.$router.push({
          path: '/login'
      })
    },
    goCenter() {
      this.$router.push(this.centerPath);
    },
    async handleLogout() {
      if (this.loggingOut) {
        return;
      }

      this.loggingOut = true;
      try {
        await logoutMemberSession();
        if (this.$store) {
          await this.$store.dispatch('user/resetToken');
        }
        clearUserSession();
        this.profileMenuVisible = false;
        this.syncUserState();
        this.$message.success('已退出登录');
        if (this.$route.path !== '/home') {
          this.$router.replace('/home');
        }
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '退出登录失败');
      } finally {
        this.loggingOut = false;
      }
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) {
        const navHeight = this.$el && this.$el.offsetHeight ? this.$el.offsetHeight : 74;
        const extraOffsetMap = {
          support: 70,
          finance: 70
        };
        const extraOffset = extraOffsetMap[id] || 0;
        const targetTop = el.getBoundingClientRect().top + window.pageYOffset - navHeight - extraOffset;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: 'smooth'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 120;
  width: 100%;
  height: 74px;
  background: rgba(255, 255, 255, 0.96);
}

.nav-inner {
  width: 1200px;
  max-width: calc(100vw - 32px);
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.brand {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.brand-logo {
  width: 275px;
  display: block;
}

.nav-list {
  display: flex;
  align-items: center;
  gap: 28px;
  margin-left: 140px;
}

.nav-item {
  border: 0;
  background: transparent;
  color: #4a547f;
  font-size: 15px;
  cursor: pointer;
}

.nav-item:hover {
  color: #6c79fb;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.profile-entry {
  position: relative;
}

.profile-link {
  min-width: 116px;
  height: 44px;
  padding: 0 14px;
  border:0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.96);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #6166ce;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.profile-avatar {
  object-fit: cover;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(93, 96, 106, 0.5);
  background: conic-gradient(from 0deg, #9F64FF, #528AFF);
  padding: 2px;
  box-sizing: border-box;
  position: relative;
}

.profile-menu {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 10;
  min-width: 116px;
  padding: 8px;
  border: 1px solid #e5e9f7;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(72, 84, 132, 0.14);
}

.profile-menu-item {
  width: 100%;
  height: 36px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #303a62;
  font-size: 14px;
  cursor: pointer;
}

.profile-menu-item:hover:not(:disabled) {
  background: #f3f5ff;
  color: #5b63f3;
}

.profile-menu-item:disabled {
  cursor: not-allowed;
  color: #a0a7c2;
}

.btn {
  height: 44px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.login {
  width: 82px;
  background: #fff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #9A9CE8;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 500;
  font-size: 15px;
  color: #6166CE;
}

.apply {
  width: 120px;
  border: 0;
  color: #fff;
  background: linear-gradient( 117deg, #518BFF 0%, #9E5DFF 100%);
  box-shadow: 0px 4px 14px 0px rgba(99,102,241,0.35);
  border-radius: 10px 10px 10px 10px;
}

@media (max-width: 980px) {
  .nav-wrap {
    height: auto;
    padding: 10px 0;
  }

  .nav-inner {
    flex-wrap: wrap;
    gap: 12px;
  }

  .nav-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .brand-logo {
    width: 220px;
  }

  .nav-list {
    order: 3;
    margin-left: 0;
    gap: 14px;
    flex-wrap: wrap;
	width: 450px;
  }
}
</style>
